angular.module('rjmNg.common.api').factory 'serviceUrl', [
  "serviceRoot"
  (serviceRoot) ->
    (url) ->
      return "#{serviceRoot}#{url}"
]
